import { render } from "./LabView.vue?vue&type=template&id=cf38eb18"
import script from "./LabView.vue?vue&type=script&lang=js"
export * from "./LabView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__